// Import style file
import {
    ProductCardContainer,
    ProductImageContainer,
    ProductImage,
    ProductPriceCard,
    ProductPrice,
    ProductOfferCard,
    ProductOffer,
    ProductButton,
    ProductTitle,
} from './style';

// Import assets
import imageNotFound from '../../assets/images/imageNotFound.png';

// Import texts
import productTexts from '../../texts/product';

// Create the component
function ProductCard({
    title = '',
    price = '',
    isOffer = false,
    image = null,
    imageLoadedCallback = null,
}) {
    return (
        <ProductCardContainer>
            <ProductImageContainer>
                {image ? (
                    <ProductImage
                        src={image}
                        alt={title}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = imageNotFound;
                            imageLoadedCallback();
                        }}
                        onLoad={imageLoadedCallback}
                    />
                ) : (
                    <ProductImage src={imageNotFound} alt={title} />
                )}

                <ProductPriceCard>
                    <ProductPrice>{price} $</ProductPrice>
                </ProductPriceCard>
                {isOffer && (
                    <ProductOfferCard>
                        <ProductOffer>{productTexts.offer}</ProductOffer>
                    </ProductOfferCard>
                )}
            </ProductImageContainer>
            <ProductButton>
                <ProductTitle>{title}</ProductTitle>
            </ProductButton>
        </ProductCardContainer>
    );
}

export default ProductCard;
